import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SideMenuUtilService {
  constructor() { }

  getMenuForCompany(isMobileDevice: boolean) {
    return [
      {
        title: 'Home',
        icon: 'fa fa-home',
        path: isMobileDevice ? 'old-company-home' :'company-home',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/home'
      },
      {
        title: 'Hire an employee',
        icon: 'fa fa-bullhorn',
        path: 'hire-staffy',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/create-shifts',

        subMenu: [
          {
            title: 'Create Shift',
            icon: 'fa fa-bullhorn',
            path: 'company-recurrent-shifts',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/create-shifts'
          },
          {
            title: 'Direct Hire',
            icon: 'fa fa-search',
            path: 'company-direct-hire',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/direct-hire'
          },
          // {
          //   title: 'New Broadcast',
          //   icon: 'fa fa-bullhorn',
          //   path: 'company-broadcast-request',
          //   forApprovedUserOnly: false,
          //   navigateUrl:  'company-dashboard/broadcast-request'
          // },
          {
            title: 'Shift-Loader Pro',
            icon: 'fa fa-calendar',
            path: 'multi-shift-builder',
            forApprovedUserOnly: false,
            navigateUrl:  'company-dashboard/multi-shift-builder'
          }
        ]
      },
      {
        title: 'Patients',
        icon: 'fas fa-tasks',
        path: 'patients',
        forApprovedUserOnly: false,
        forHomeCareClientOnly: true,
        navigateUrl: 'company-dashboard/patients'
      },
      {
        title: 'Notifications',
        icon: 'fa fa-bell',
        path: 'company-notifications',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/notifications'
      },
      {
        title: 'Requests',
        icon: 'fa fa-hand-paper',
        path: 'company-requests',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/shift-requests/unfilled/all',

        subMenu: [
          {
            title: 'Unfilled Requests',
            icon: 'fa fa-bullhorn',
            path: 'company-unfilled-request',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/shift-requests/unfilled/all'
          },
          {
            title: 'Filled Requests',
            icon: 'fa fa-bell',
            path: 'company-filled-request',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/shift-requests/filled/all'
          },
          {
            title: 'Shifts Calender',
            icon: 'fa fa-calendar',
            path: 'company-filled-request-calendar',
            forApprovedUserOnly: false,
            mobHidden: true,
            navigateUrl: 'company-dashboard/full-calender'
          },
          {
            title: 'Previous Shifts',
            icon: 'fa fa-history',
            path: 'company-previous-shifts',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/previous-shifts/all'
          }
        ]
      },
      {
        title: 'Ongoing shifts',
        icon: 'fa fa-bullseye',
        path: 'ongoing-shifts',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/shift-requests/ongoing-shifts/all',

      },
      {
        title: 'Previous Staffies',
        icon: 'fa fa-address-book',
        path: 'company-previous-staffies',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/previous-staffies'

      },
      {
        title: 'Teams',
        icon: 'fa fa-users',
        path: 'company-teams',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/teams'
      },
      {
        title: 'Settings',
        icon: 'fa fa-wrench',
        path: 'settings',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/business-profile',

        subMenu: [
          {
            title: 'Business Profile',
            icon: 'fa fa-suitcase',
            path: 'company-profile',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/business-profile',
          },
          {
            title: 'Block Staffies',
            icon: 'fa fa-ban',
            path: 'company-block-staffies',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/block-staffies',
          },
          {
            title: 'Addresses',
            icon: 'fa fa-address-book',
            path: 'company-other-addresses',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/other-addresses'
          },
          {
            title: 'Notifications',
            icon: 'fa fa-bell',
            path: 'company-notification-preferences',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/notification-preferences'
          },
          {
            title: 'Auto Hire',
            icon: 'fa fa-street-view',
            path: 'company-auto-hire',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/auto-hire'
          },
          {
            title: 'Tasks',
            icon: 'fas fa-tasks',
            path: 'company-tasks',
            forApprovedUserOnly: false,
            navigateUrl: 'company-dashboard/tasks',
            forHomeCareClientOnly: true
          },
        ]
      },
      {
        title: 'FAQ',
        icon: 'fa fa-question',
        path: 'company-faq',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/faqs'
      },
      {
        title: 'Contact Us',
        icon: 'fa fa-envelope',
        path: 'company-contact-us',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/contact-us'
      },
      {
        title: 'Privacy Policy',
        icon: 'fa fa-print',
        path: 'privacy-agreement',
        forApprovedUserOnly: false,
        navigateUrl: 'company-dashboard/privacy-policy'
      },
      {
        title: 'Logout',
        icon: 'fa fa-sign-out-alt',
        path: 'logout',
        forApprovedUserOnly: false
      }
    ];
  }
  getMenuForStaffy() {
    return [
      {
        title: 'Home',
        icon: 'fa fa-home',
        path: 'talent-home',
        forApprovedUserOnly: false
      },
      {
        title: 'Edit profile',
        icon: 'fa fa-user',
        path: 'talent-set-profile',
        forApprovedUserOnly: false,
      },
      {
        title: 'Shifts',
        icon: 'fa fa-clone',
        path: 'shifts',
        expand: true,
        forApprovedUserOnly: true,

        subMenu: [
          {
            title: 'Available shifts',
            icon: 'fa fa-briefcase',
            path: 'talent-home',
            forApprovedUserOnly: true
          },
          {
            title: 'Upcoming shifts',
            icon: 'fa fa-arrow-up',
            path: 'upcoming-shifts',
            forApprovedUserOnly: true
          },{
            title: 'Confirm your shifts',
            icon: 'fa fa-check-square',
            path: 'shifts-confirmation',
            forApprovedUserOnly: true
          },
          {
            title: 'My Applications',
            icon: 'fa fa-envelope-open',
            path: 'my-applications',
            forApprovedUserOnly: true
          },
        ]
      },
      {
        title: 'Timesheets',
        icon: 'fas fa-clock',
        path: 'talent-billing',
        expand: true,
        forApprovedUserOnly: true,

        subMenu: [
           {
            title: 'Add Manual Time',
            path: 'talent-log-hours'
          },
          {
            title: 'Unverified Hours',
            path: 'talent-unverified-hours'
          }
        ]
      },
      {
        title: 'Set Availability',
        icon: 'fa fa-clock',
        path: 'set-availability',
        forApprovedUserOnly: true
      },
      {
        title: 'FAQ',
        icon: 'fa fa-question',
        path: 'talent-faq',
        forApprovedUserOnly: false
      },
      {
        title: 'Help',
        icon: 'fas fa-hands-helping',
        path: 'talent-help',
        expand: true,
        forApprovedUserOnly: false,
        subMenu: [
          {
            title: 'Help',
            icon: 'fa fa-question',
            path: 'talent-help-page',
            forApprovedUserOnly: false
          }
        ]
      },
      {
        title: 'Settings',
        icon: 'fa fa-cog',
        path: 'settings',
        expand: true,
        forApprovedUserOnly: false,

        subMenu: [
        {
          title: 'Notifications',
          icon: 'fa fa-bell',
          path: 'talent-notification-preferences',
          forApprovedUserOnly: false
        },
        ]
      },
      {
        title: 'Privacy Policy',
        icon: 'fa fa-print',
        path: 'privacy-policy',
        forApprovedUserOnly: false
      },
      {
        title: 'Logout',
        icon: 'fa fa-sign-out-alt',
        path: 'logout',
        forApprovedUserOnly: false
      }
    ];
  }
}
